import { CloseOutlined, MenuOutlined } from "@ant-design/icons";
import { Button, Col, Drawer, Row } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import TwizzImg from "../../../assets/icons/twizz-logo-white.svg";
import "./index.less";

const HomePageNavbarComponent = () => {
  const { t } = useTranslation();

  const navItem = [
    { key: "auth-signUp-title-arrow", link: "/auth/signUp" },
  ];

  const btnItem = [
    { key: "auth-signIn", link: "/auth/signIn" },
  ];

  const navItem2 = [...navItem, ...btnItem];

  const [drawerVisible, setDrawerVisible] = useState(false);

  const showDrawer = () => {
    setDrawerVisible(true);
  };

  const closeDrawer = () => {
    setDrawerVisible(false);
  };

  return (
    <div className="blog-navbar">
      <Row className="navbar" align="middle">
        {/* Logo */}
        <Col className="logo-container">
          <Link to="/">
            <img src={TwizzImg} alt="Twizz" className="logo" />
          </Link>
        </Col>
        {/* Desktop Menu */}
        <Row style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap :"10px" }}>
          <Col className="desktop-menu">
            {navItem.map((item, index) => (
              <Link to={item?.link}>
                <Button type="text" className="nav-item" key={index}>
                  {t(item.key)}
                </Button>
              </Link>
            ))}
          </Col>
          {/* Desktop Buttons */}
          <Col className="desktop-buttons">
            {btnItem.map((item, index) => (
              <Link to={item?.link}>
                <Button key={index} type="default" shape="round" className={index === 0 ? "login-btn" : "register-btn"}>
                  {t(item.key)}
                </Button>
              </Link>
            ))}
          </Col>
          {/* Hamburger Menu for Mobile */}
          <Col className="mobile-menu-container">
            <Button type="text" className="mobile-btn-menu" onClick={showDrawer}>
              <MenuOutlined className="icon-menu" />
            </Button>
          </Col>
        </Row>
      </Row>
      {/* Mobile Drawer */}
      <Drawer placement="right" open={drawerVisible} width="100%" className="mobile-drawer">
        <div className="mobile-menu-content">
          <div className="mobile-header">
            <img src={TwizzImg} alt="Twizz" className="mobile-logo" />
            closeIcon={<CloseOutlined className="close-icon" onClick={closeDrawer} />}
          </div>
          <div className="mobile-menu">
            {navItem2.map((item, index) => (
              <Link to={item?.link}>
                <Button type="text" className="mobile-nav-item" key={index}>
                  {t(item.key)}
                </Button>
              </Link>
            ))}
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default HomePageNavbarComponent;
